import { Routes, Route, Navigate } from "react-router-dom"
import { useEffect } from "react"
import { useDeviceStore } from "./state/deviceStore"
import { useAuthStore } from "./state/authStore"
import DeviceSetupPage from "./pages/DeviceSetupPage"
import WaiterPickerPage from "./pages/WaiterPickerPage"
import PinPage from "./pages/PinPage"
import NarudzbeListPage from "./pages/NarudzbeListPage"
import OrderPage from "./pages/OrderPage"
import ActiveOrdersPage from "./pages/ActiveOrdersPage"
import AdminLoginPage from "./pages/AdminLoginPage"
import AdminDashboardPage from "./pages/AdminDashboardPage"
import NetworkIndicator from "./components/NetworkIndicator"

function ProtectedWaiterRoute({ children }: { children: React.ReactNode }) {
    const token = useAuthStore(s => s.token)
    const sessionType = useAuthStore(s => s.sessionType)
    if (!token || sessionType !== "WAITER") return <Navigate to="/login" replace />
    return <>{children}</>
}

function ProtectedAdminRoute({ children }: { children: React.ReactNode }) {
    const token = useAuthStore(s => s.token)
    const sessionType = useAuthStore(s => s.sessionType)
    if (!token || sessionType !== "ADMIN") return <Navigate to="/admin/login" replace />
    return <>{children}</>
}

export default function App() {
    const deviceUuid = useDeviceStore(s => s.deviceUuid)
    const loadDevice = useDeviceStore(s => s.load)
    useEffect(() => { loadDevice() }, [loadDevice])

    return (
        <div className="h-full flex flex-col bg-slate-50">
            <NetworkIndicator />
            <Routes>
                <Route path="/" element={deviceUuid ? <Navigate to="/login" replace /> : <Navigate to="/setup" replace />} />
                <Route path="/setup" element={<DeviceSetupPage />} />
                <Route path="/login" element={deviceUuid ? <WaiterPickerPage /> : <Navigate to="/setup" replace />} />
                <Route path="/pin/:waiterId" element={<PinPage />} />
                <Route path="/narudzbe" element={<ProtectedWaiterRoute><NarudzbeListPage /></ProtectedWaiterRoute>} />
                <Route path="/order/:narudzbaId" element={<ProtectedWaiterRoute><OrderPage /></ProtectedWaiterRoute>} />
                <Route path="/active" element={<ProtectedWaiterRoute><ActiveOrdersPage /></ProtectedWaiterRoute>} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboardPage /></ProtectedAdminRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    )
}